<div role="main" class="app-content-area container">
    <!-- <p>CONTENT-PLACEHOLDER</p> -->
    <ng-content></ng-content>
    <router-outlet></router-outlet>
</div>